import { County } from "types/State";
import { BaseService } from "./baseService";

class CountyService extends BaseService<County> {
  controllerName = "counties";
}

export const countyService = new CountyService();
